<template>
  <v-container grid-list-xl>
    <v-layout row wrap>
      <user-control></user-control>
      <user-view></user-view>
    </v-layout>
  </v-container>
</template>

<script>
import UserControl from "@/components/users/userControl";
import UserView from "@/components/users/userView";
export default {
  components: {
    UserControl,
    UserView
  }
};
</script>

<style>
</style>
